import { render } from "./EscalatedClientPostsToolbar.vue?vue&type=template&id=3d781493&ts=true"
import script from "./EscalatedClientPostsToolbar.vue?vue&type=script&lang=ts"
export * from "./EscalatedClientPostsToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__